import { AppInitAction } from "./actions/types"
import { AppInitState } from "./types"

export const initialState: AppInitState = {
  isInitialized: false,
  isLoading: false,
  error: null,
  plateformes: []
}

export const appInitReducer = (
  state: AppInitState,
  action: AppInitAction
): AppInitState => {
  switch (action.type) {
    case 'SET_LOADING':
      return { ...state, isLoading: action.payload }
    case 'SET_ERROR':
      return { ...state, error: action.payload, isLoading: false }
    case 'SET_INITIALIZED':
      return { ...state, isInitialized: action.payload }
    case 'SET_ORGANIZATION_DATA':
      return {
        ...state,
        currentPlateforme: action.payload.currentPlateforme,
        plateformes: action.payload.plateformes,
        theme: action.payload.theme,
        isInitialized: true,
        isLoading: false,
        error: null
      }
    case 'SWITCH_ORGANIZATION':
      return {
        ...state,
        currentPlateforme: action.payload.currentPlateforme,
        theme: action.payload.theme
      }
    case 'RESET':
      return initialState
    default:
      return state
  }
}
